import React, { useState, useContext } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { AuthContext } from "./AuthContext";
import axios from "axios";
import { isMobileOnly } from "react-device-detect";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { useForm } from "react-hook-form";
import GuestbookLight from "../UI/Icons/GuestbookLight";
import Present from "../UI/Icons/Present";
import MoneyCloud from "../UI/Icons/MoneyCloud";
import Close from "../UI/Icons/Close";
import GuestbookWide from "../UI/Icons/GuestbookWide";
import Button from "../UI/Button";
import { InputWrapper } from "../UI/InputWrapper";
import styled from "styled-components";
import {
  numOfHotels,
  guestbookSites,
  environment,
  honeybadger,
} from "../../settings/IntegrationConstants";
import I18n from "../../translations/i18n";
import translations from "../../hotel_integration_modules/utilities/translations";

type LoginModalProps = {
  modalSectionType: string;
  setModalSectionType: React.Dispatch<React.SetStateAction<string>>;
  showLoginModal: boolean;
  handleClose: () => void;
  locale: string;
};

type DescriptionSectionProps = {
  locale: string;
};

type LoginSectionProps = {
  modalSectionType: string;
  setModalSectionType: React.Dispatch<React.SetStateAction<string>>;
  locale: string;
  handleClose: () => void;
};

type LoginSignupProps = {
  locale: string;
  handleClose: () => void;
  setSectionType: React.Dispatch<React.SetStateAction<string>>;
  setAlertMessage: React.Dispatch<React.SetStateAction<string>>;
  setShowAlert: React.Dispatch<React.SetStateAction<boolean>>;
};

const StyledModalContainer = styled(Modal)`
  font-family: ${({ theme }) => theme.primaryFont};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2147483647 !important;

  ${isMobileOnly &&
  `
    @media (orientation: landscape) {
      overflow: scroll;
    }
  `}
`;

const StyledModal = styled.div`
  background-color: #ffffff;
  width: 965px;
  height: 552px;
  outline: none;
  display: flex;

  ${({ theme }) => theme.tablet`
    height: 100%;
  `}
`;

const DescriptionSectionContainer = styled.div`
  background-color: #343434;
  color: #ffffff;
  flex: 50%;
  padding: 24px;
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.tablet`
    display: none;
  `}

  ${isMobileOnly &&
  `
    display: none;
  `}
`;

const MobileCoBrandedSectionContainer = styled.div`
  display: none;

  ${({ theme }) => theme.tablet`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: -250px 0 40px 10px;
  `}
`;

const LoginSignupSectionContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: 24px;
  flex: 50%;
  color: #000000;

  ${isMobileOnly &&
  `
    @media (orientation: landscape) {
      top: 100px;
      background: #ffffff;
    }
  `}
`;

const LoginContainer = styled.div`
  padding: 0px 8px;
`;

const LoginHeader = styled.div`
  color: #000000;
  font-weight: 600;
  font-size: 18px;
`;

const LoginFooterContainer = styled.div`
  color: #666666;
  font-weight: 400;
  margin-top: 16px;
`;

const TermsPrivacyLine = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.primaryColor};
  margin-bottom: 8px;

  a {
    border-bottom: none;
    color: ${({ theme }) => theme.primaryColor} !important;

    &:hover {
      opacity: 0.75;
    }

    &:focus {
      color: ${({ theme }) => theme.primaryColor} !important;
      opacity: 0.75;
    }
  }
`;

const RedirectLine = styled.div`
  font-size: 16px;
  line-height: 24px;

  span {
    cursor: pointer;
    color: ${({ theme }) => theme.primaryColor};
  }
`;

const NeedHelpLine = styled.div`
  font-size: 14px;
  margin-top: 8px;
  line-height: 21px;

  a {
    font-weight: 400;
    border-bottom: none;
    color: ${({ theme }) => theme.primaryColor} !important;

    &:hover {
      opacity: 0.75;
    }

    &:focus {
      color: ${({ theme }) => theme.primaryColor} !important;
      opacity: 0.75;
    }
  }
`;

const StyledForm = styled.form`
  margin: 24px 0px 24px;
`;

const ButtonContainer = styled.div`
  margin-top: 8px;
`;

const InputErrorWrapper = styled.div`
  position: relative;
  margin-bottom: 20px;
`;

const ErrorWrapper = styled.div`
  text-align: left;
  color: red;
  font-family: ${({ theme }) => theme.secondaryFont};
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  margin-bottom: 0 !important;
  position: absolute;
  top: 0;
  background: #fffefc;
  width: 100%;

  ${({ theme }) => theme.mobileS`
    font-size: 11px;
   `}
`;

const SuccessIconContainer = styled.div`
  margin-bottom: 24px;

  path {
    fill: #231f20;
  }
`;

const SuccessMessageText = styled.div`
  color: #666666;
  font-size: 16px;
  line-height: 22px;
  margin: 24px 0px 30px;
`;

const GoogleButtonContainer = {
  style: {
    margin: "36px auto",
    display: "flex",
    justifyContent: "center"
  },
  
  'className': 'googleLoginContainer'
}

const LoginFromDifferent = styled.div`
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
`;

const DescriptionSectionHeader = styled.div`
  display: flex;
  flex: 50%;
  flex-direction: column;
`;

const DescriptionSectionHeaderText = styled.div`
  font-size: 16px;
  line-height: 24px;
  padding-top: 4px;
  max-width: 350px;
  color: #ffffff;
`;

const DescriptionLogoContainer = styled.div`
  margin-right: 16px;
`;

const CoBrandedLogo = styled.img`
  height: 80px;
  margin-bottom: 10px;
`;

const CoBrandedDescriptionHeaderText = styled.div`
  font-size: 20px;
  line-height: 24px;
  margin-top: 12px
  padding-top: 4px;
  max-width: 350px;
  color: #ffffff;
`;

const CoBrandedDescriptionHeaderSubText = styled.div`
  font-size: 12px;
  line-height: 24px;
  padding-top: 4px;
  max-width: 350px;
  color: #ffffff;
  font-weight: 600;
`;

const MobileCoBrandedDescriptionHeaderText = styled.div`
  font-size: 18px;
  line-height: 24px;
  padding-top: 4px;
  max-width: 350px;
  color: #000000;
`;

const MobileCoBrandedDescriptionHeaderSubText = styled.div`
  font-size: 10px;
  line-height: 24px;
  padding-top: 4px;
  max-width: 350px;
  color: #000000;
  font-weight: bold;
`;

const DescriptionSectionDetails = styled.div`
  flex: 50%;
`;

const DetailsHeader = styled.div`
  display: flex;
  margin-bottom: 16px;
`;

const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 16px;
`;

const DetailsHeaderText = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: #ffffff;
`;

const DetailsTextDescription = styled.div`
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 32px;
  color: #ffffff;
`;

const DetailsTextList = styled.ul`
  font-size: 16px;
  margin-left: 10px;

  a {
    color: #ffffff !important;
    font-weight: 400;
    border-bottom: none;
    text-decoration: underline;
  }

  li {
    color: #ffffff;
  }
`;

const CloseIconContainer = styled.div`
  cursor: pointer;
  width: fit-content;
  position: absolute;
  top: 16px;
  right: 16px;
`;

const StyledSnackbar = styled(Snackbar)`
  .MuiSnackbarContent-root {
    background-color: #f44336;
  }
`;

const hotelSettings = window.gb_data.hotel;
const cobrandingEnabled = hotelSettings.cobrandingEnabled;
const hotelLogoURL = hotelSettings.hotelLogoURL;

const DescriptionSection = ({ locale }: DescriptionSectionProps) => {
  return (
    <DescriptionSectionContainer>
      <DescriptionSectionHeader>
        <DescriptionLogoContainer>
          {(cobrandingEnabled) ? (
            <CoBrandedLogo src={hotelLogoURL}></CoBrandedLogo>
          ):(
            <GuestbookLight />
          )}
        </DescriptionLogoContainer>
        {(cobrandingEnabled) ? (
          <div>
            <CoBrandedDescriptionHeaderText>
              {hotelSettings.whiteLabel}
            </CoBrandedDescriptionHeaderText>
            <CoBrandedDescriptionHeaderSubText>
              {`${translations("login", "powered_by", locale)}`}
            </CoBrandedDescriptionHeaderSubText>
          </div>
        ):(
          <DescriptionSectionHeaderText>
            {I18n.t(`views.hotel_integration.components.login.description`, {
              locale: `${locale}`,
              num_of_hotels: numOfHotels,
            })}
          </DescriptionSectionHeaderText>
        )}
      </DescriptionSectionHeader>
      <DescriptionSectionDetails>
        <div>
          <DetailsHeader>
            <IconContainer>
              <Present />
            </IconContainer>
            <DetailsHeaderText>
              {`${translations("login", "earn_fifteen", locale)} `}
            </DetailsHeaderText>
          </DetailsHeader>
          <DetailsTextDescription>
            {I18n.t(
              `views.hotel_integration.components.login.earn_by_booking_direct`,
              {
                locale: `${locale}`,
                num_of_hotels: numOfHotels,
              }
            )}
          </DetailsTextDescription>
        </div>
        <div>
          <DetailsHeader>
            <IconContainer>
              <MoneyCloud />
            </IconContainer>
            <DetailsHeaderText>
              {`${translations("login", "redeem_after_stay", locale)} `}:
            </DetailsHeaderText>
          </DetailsHeader>
          <DetailsTextList>
            <li>{`${translations("login", "cash_back", locale)} `}</li>
            <li>{`${translations("login", "cash_for_a_cause", locale)} `}</li>
            <li>
              {I18n.t(`views.hotel_integration.components.login.cash_forward`, {
                locale: `${locale}`,
                num_of_hotels: numOfHotels,
              })}
              &nbsp;
              <a
                href="https://theguestbook.com"
                target="_blank"
                rel="noreferrer"
              >
                The Guestbook
              </a>
            </li>
          </DetailsTextList>
        </div>
      </DescriptionSectionDetails>
    </DescriptionSectionContainer>
  );
};

const Login = ({
  locale,
  handleClose,
  setSectionType,
  setAlertMessage,
  setShowAlert,
}: LoginSignupProps) => {
  const authContext: any = useContext(AuthContext);
  const [showGoogleLogin, setShowGoogleLogin] = useState(false);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [showPasswordInput, setShowPasswordInput] = useState(false);
  const [pending, setPending] = useState(false);
  const {
    control,
    errors,
    formState,
    reset,
    handleSubmit,
    register,
    setValue,
  } = useForm({ mode: "onSubmit" });

  type emailSubmissionData = {
    email: string;
  };

  type passwordSubmissionData = {
    email: string;
    password: string;
  };

  const onSubmitEmail = (data: emailSubmissionData) => {
    setPending(true);
    const submissionData = {
      email: data.email,
      wid: window.gb_data.widget.identifier,
    };
    axios
      .get(
        `${
          guestbookSites[environment as string].rewardsdash.url
        }/api/v1/bei/user_type`,
        {
          params: submissionData,
        }
      )
      .then((response) => {
        if (response.status === 200) {
          setEmail(data.email);

          if (response.data.login_type === "google") {
            setName(response.data.first_name);
            setShowGoogleLogin(true);
          } else {
            setShowPasswordInput(true);
          }
          reset();
        } else {
          console.log(response);
        }
        setPending(false);
      })
      .catch((error) => {
        if (error.response.data.error === "User not found.") {
          setAlertMessage(`${translations("login", "user_not_found", locale)}`);
          setShowAlert(true);
          setSectionType("signup");
        } else if (error.response.data.error === "Unactivated account.") {
          setAlertMessage(
            `${translations("login", "unactivated_account", locale)}`
          );
          setShowAlert(true);
          reset();
        } else {
          console.log(error.response.data.error);
          // honeybadger.notify(`Signup error: ${error.response.data.error}`, {
          //   tags: "new_bei, login_signup_modal",
          // });
        }
        setPending(false);
      });
  };

  const onSubmitPassword = (data: passwordSubmissionData) => {
    setPending(true);
    const submissionData = {
      email: email,
      wid: window.gb_data.widget.identifier,
      password: data.password,
    };
    axios
      .get(
        `${
          guestbookSites[environment as string].rewardsdash.url
        }/api/v1/bei/password_login`,
        {
          params: submissionData,
        }
      )
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem("gb_storage_key", response.data.user_token);
          authContext.authenticate();
          handleClose();
        } else {
          console.log(response);
        }
        setPending(false);
      })
      .catch((error) => {
        if (error.response.data.error === "Incorrect password") {
          setAlertMessage(
            `${translations("login", "incorrect_password", locale)}`
          );
          setShowAlert(true);
          reset();
        } else {
          console.log(error.response.data.error);
          // honeybadger.notify(`Signup error: ${error.response.data.error}`, {
          //   tags: "new_bei, login_signup_modal",
          // });
        }
        setPending(false);
      });
  };

  const onResponseGoogle = (response: any) => {
    const submissionData = {
      google_id_token: response.credential,
    };
    axios
      .get(
        `${
          guestbookSites[environment as string].rewardsdash.url
        }/api/v1/bei/google_login`,
        {
          params: submissionData,
        }
      )
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem("gb_storage_key", response.data.user_token);
          authContext.authenticate();
        } else {
          console.log(response);
        }
      })
      .catch((error) => {
        if (error.response.data.error === "User not found.") {
          console.log("User not found!");
          setSectionType("signup");
        } else {
          setAlertMessage(
            `${translations("login", "something_went_wrong", locale)}`
          );
          setShowAlert(true);
          console.log(error.response.data.error);
          // honeybadger.notify(`Signup error: ${error.response.data.error}`, {
          //   tags: "new_bei, login_signup_modal",
          // });
        }
      });
    handleClose();
  };

  return (
    <LoginContainer>
      {showGoogleLogin ? (
        <>
          <LoginHeader>
            {I18n.t("views.hotel_integration.components.login.welcome", {
              name: `${name}`,
              locale: `${locale}`,
            })}
          </LoginHeader>
          <GoogleLogin 
            containerProps={GoogleButtonContainer}
            onSuccess={credentialResponse => {
              onResponseGoogle(credentialResponse);
            }}
            theme="filled_blue"
            size="large"
            type="standard"  
            shape="rectangular"
            logo_alignment="left"
            locale = {`${locale}`}  
            onError={() => {
              onResponseGoogle({credential: ""});
            }}
            />
          <LoginFromDifferent
            tabIndex={0}
            role="button"
            onClick={() => setShowGoogleLogin(false)}
            onKeyPress={() => setShowGoogleLogin(false)}
          >
            {`${translations("login", "login_different_account", locale)} `}
          </LoginFromDifferent>
        </>
      ) : (
        <>
          <LoginHeader>
            {`${translations("login", "login_title", locale)} `}
          </LoginHeader>
          <StyledForm
            onSubmit={
              showPasswordInput
                ? (event) => {
                    event.preventDefault();
                    handleSubmit(onSubmitPassword)();
                  }
                : (event) => {
                    event.preventDefault();
                    (document.getElementById(
                      "login_email"
                    ) as HTMLInputElement).value = (document.getElementById(
                      "login_email"
                    ) as HTMLInputElement).value.trim();
                    handleSubmit(onSubmitEmail)();
                  }
            }
          >
            {showPasswordInput ? (
              <InputErrorWrapper>
                <InputWrapper
                  labelText={`${translations(
                    "login",
                    "password_label",
                    locale
                  )} `}
                  id="password"
                  isErrorLabel={false}
                  type="password"
                >
                  <input
                    name="password"
                    type="password"
                    placeholder={`${translations(
                      "login",
                      "password_placeholder",
                      locale
                    )} `}
                    ref={register({ required: "Required" })}
                  />
                </InputWrapper>
                <ErrorWrapper>
                  {errors.password &&
                    `${translations("login", "password_error", locale)}`}
                </ErrorWrapper>
              </InputErrorWrapper>
            ) : (
              <InputErrorWrapper>
                <InputWrapper
                  labelText={`${translations("login", "email_label", locale)} `}
                  id="email"
                  isErrorLabel={false}
                  type="text"
                >
                  <input
                    name="email"
                    id="login_email"
                    placeholder={`${translations(
                      "login",
                      "email_placeholder",
                      locale
                    )} `}
                    ref={register({
                      required: `${translations(
                        "login",
                        "email_required",
                        locale
                      )}`,
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                        message: `${translations(
                          "login",
                          "invalid_email",
                          locale
                        )}`,
                      },
                    })}
                  />
                </InputWrapper>
                <ErrorWrapper>
                  {errors.email && errors.email.message}
                </ErrorWrapper>
              </InputErrorWrapper>
            )}
            <ButtonContainer>
              <Button
                kind="primary"
                disabled={pending}
                loading={pending}
                onClick={
                  showPasswordInput
                    ? () => handleSubmit(onSubmitPassword)()
                    : () => {
                        (document.getElementById(
                          "login_email"
                        ) as HTMLInputElement).value = (document.getElementById(
                          "login_email"
                        ) as HTMLInputElement).value.trim();
                        handleSubmit(onSubmitEmail)();
                      }
                }
                type="button"
                className="gb-login-modal-button"
              >
                {`${translations("login", "login", locale)} `}
              </Button>
            </ButtonContainer>
          </StyledForm>
          <LoginFooterContainer>
            <TermsPrivacyLine>
              <a
                href="https://theguestbook.com/terms"
                target="_blank"
                rel="noreferrer"
              >
                {`${translations("login", "terms", locale)} `}
              </a>{" "}
              |{" "}
              <a
                href="https://theguestbook.com/privacy"
                target="_blank"
                rel="noreferrer"
              >
                {`${translations("login", "privacy", locale)} `}
              </a>
            </TermsPrivacyLine>
            <RedirectLine>
              {`${translations("login", "new_to_guestbook", locale)} `} The
              Guestbook?{" "}
              <span
                tabIndex={0}
                role="button"
                onClick={() => setSectionType("signup")}
                onKeyPress={() => setSectionType("signup")}
              >{`${translations("login", "signup_button", locale)} `}</span>
            </RedirectLine>
            <NeedHelpLine>
              {`${translations("login", "need_help", locale)} `}{" "}
              <a
                href="https://theguestbook.com"
                target="_blank"
                rel="noreferrer"
              >
                theguestbook.com
              </a>
            </NeedHelpLine>
          </LoginFooterContainer>
        </>
      )}
    </LoginContainer>
  );
};

const Signup = ({
  locale,
  handleClose,
  setSectionType,
  setAlertMessage,
  setShowAlert,
}: LoginSignupProps) => {
  const authContext: any = useContext(AuthContext);
  const {
    control,
    errors,
    formState,
    reset,
    handleSubmit,
    register,
    setValue,
  } = useForm({ mode: "onSubmit" });

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [pending, setPending] = useState(false);

  type submissionData = {
    email: string;
    first_name: string;
    last_name: string;
  };

  const onSubmit = (data: submissionData) => {
    // REMOVE
    console.log("environment as string:", environment as string );
    console.log("guestbookSites[environment as string]:", guestbookSites[environment as string] );
    console.log("URL:", guestbookSites[environment as string].rewardsdash.url );
    // end remove
    
    setPending(true);
    const submissionData = {
      account: {
        ...data,
        wid: window.gb_data.widget.identifier,
        source: 'booking_engine_widget'
      },
    };
    axios
      .post(
        `${
          guestbookSites[environment as string].rewardsdash.url
        }/api/v1/accounts`,
        submissionData,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((response) => {
        if (response.status === 201) {
          localStorage.setItem("gb_storage_key", response.data.user_token);
          authContext.authenticate();
          setShowSuccessMessage(true);
          reset();
        } else {
          console.log(response);
        }
        setPending(false);
      })
      .catch((error) => {
        if (error.response.data.error === "Account exists for platform.") {
          setAlertMessage(`${translations("login", "user_exists", locale)}`);
          setShowAlert(true);
          setSectionType("login");
        } else {
          console.log(error.response.data.error);
          // honeybadger.notify(`Signup error: ${error.response.data.error}`, {
          //   tags: "new_bei, login_signup_modal",
          // });
        }
        setPending(false);
      });
  };

  return (
    <LoginContainer>
      {showSuccessMessage ? (
        <>
          <SuccessIconContainer>
            <GuestbookWide />
          </SuccessIconContainer>
          <LoginHeader>
            {`${translations("login", "account_success", locale)} `}
          </LoginHeader>
          <SuccessMessageText>{`${translations(
            "login",
            "check_inbox",
            locale
          )} `}</SuccessMessageText>
          <Button kind="primary" onClick={() => handleClose()} type="button">
            {`${translations("login", "close", locale)} `}
          </Button>
        </>
      ) : (
        <>
          <LoginHeader>
            {`${translations("login", "enroll_title", locale)} `} The Guestbook
          </LoginHeader>
          <StyledForm
            onSubmit={(event) => {
              event.preventDefault();
              (document.getElementById(
                "signup_email"
              ) as HTMLInputElement).value = (document.getElementById(
                "signup_email"
              ) as HTMLInputElement).value.trim();
              handleSubmit(onSubmit)();
            }}
          >
            <InputErrorWrapper>
              <InputWrapper
                labelText={`${translations("login", "email_label", locale)} `}
                id="email"
                isErrorLabel={false}
                type="text"
              >
                <input
                  id="signup_email"
                  name="email"
                  placeholder={`${translations(
                    "login",
                    "email_placeholder",
                    locale
                  )} `}
                  ref={register({
                    required: `${translations(
                      "login",
                      "email_required",
                      locale
                    )}`,
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      message: `${translations(
                        "login",
                        "invalid_email",
                        locale
                      )}`,
                    },
                  })}
                />
              </InputWrapper>
              <ErrorWrapper>
                {errors.email && errors.email.message}
              </ErrorWrapper>
            </InputErrorWrapper>
            <InputErrorWrapper>
              <InputWrapper
                labelText={`${translations(
                  "login",
                  "first_name_label",
                  locale
                )} `}
                id="first_name"
                isErrorLabel={false}
                type="text"
              >
                <input
                  name="first_name"
                  placeholder={`${translations(
                    "login",
                    "first_name_placeholder",
                    locale
                  )} `}
                  ref={register({ required: "Required" })}
                />
              </InputWrapper>
              <ErrorWrapper>
                {errors.first_name &&
                  `${translations("login", "first_name_error", locale)}`}
              </ErrorWrapper>
            </InputErrorWrapper>
            <InputErrorWrapper>
              <InputWrapper
                labelText={`${translations(
                  "login",
                  "last_name_label",
                  locale
                )} `}
                id="last_name"
                isErrorLabel={false}
                type="text"
              >
                <input
                  name="last_name"
                  placeholder={`${translations(
                    "login",
                    "last_name_placeholder",
                    locale
                  )} `}
                  ref={register({ required: "Required" })}
                />
              </InputWrapper>
              <ErrorWrapper>
                {errors.last_name &&
                  `${translations("login", "last_name_error", locale)}`}
              </ErrorWrapper>
            </InputErrorWrapper>
            <ButtonContainer>
              <Button
                kind="primary"
                disabled={pending}
                loading={pending}
                onClick={() => {
                  (document.getElementById(
                    "signup_email"
                  ) as HTMLInputElement).value = (document.getElementById(
                    "signup_email"
                  ) as HTMLInputElement).value.trim();
                  handleSubmit(onSubmit)();
                }}
                type="button"
                className="gb-login-modal-button"
              >
                {`${translations("login", "signup_button", locale)} `}
              </Button>
            </ButtonContainer>
          </StyledForm>
          <LoginFooterContainer>
            <TermsPrivacyLine>
              <a
                href="https://theguestbook.com/terms"
                target="_blank"
                rel="noreferrer"
              >
                {`${translations("login", "terms", locale)} `}
              </a>{" "}
              |{" "}
              <a
                href="https://theguestbook.com/privacy"
                target="_blank"
                rel="noreferrer"
              >
                {`${translations("login", "privacy", locale)} `}
              </a>
            </TermsPrivacyLine>
            <RedirectLine>
              {`${translations("login", "already_member", locale)} `}{" "}
              <span
                tabIndex={0}
                role="button"
                onClick={() => setSectionType("login")}
                onKeyPress={() => setSectionType("login")}
              >{`${translations("login", "login", locale)} `}</span>
            </RedirectLine>
            <NeedHelpLine>
              {`${translations("login", "need_help", locale)} `}{" "}
              <a
                href="https://theguestbook.com"
                target="_blank"
                rel="noreferrer"
              >
                theguestbook.com
              </a>
            </NeedHelpLine>
          </LoginFooterContainer>
        </>
      )}
    </LoginContainer>
  );
};

const LoginSignupSection = ({
  modalSectionType,
  setModalSectionType,
  locale,
  handleClose,
}: LoginSectionProps) => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("Error");

  const handleAlertClose = (
    event: React.SyntheticEvent | React.MouseEvent,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setShowAlert(false);
  };

  return (
    <LoginSignupSectionContainer>
      <StyledSnackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={showAlert}
        autoHideDuration={6000}
        onClose={handleAlertClose}
        message={alertMessage}
        action={
          <>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleAlertClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
      />
      <CloseIconContainer onClick={() => handleClose()}>
        <Close />
      </CloseIconContainer>
      {(cobrandingEnabled) ? (
        <MobileCoBrandedSectionContainer className="MobileCoBrandedSectionContainer">
          <CoBrandedLogo src={hotelLogoURL}></CoBrandedLogo>
          <MobileCoBrandedDescriptionHeaderText>
              {hotelSettings.whiteLabel}
          </MobileCoBrandedDescriptionHeaderText>
          <MobileCoBrandedDescriptionHeaderSubText>
            {`${translations("login", "powered_by", locale)}`}
          </MobileCoBrandedDescriptionHeaderSubText>
        </MobileCoBrandedSectionContainer>
      ) : (
        <div></div>
      )}
      {modalSectionType === "login" && (
        <Login
          locale={locale}
          handleClose={handleClose}
          setSectionType={setModalSectionType}
          setAlertMessage={setAlertMessage}
          setShowAlert={setShowAlert}
        />
      )}
      {modalSectionType === "signup" && (
        <Signup
          locale={locale}
          handleClose={handleClose}
          setSectionType={setModalSectionType}
          setAlertMessage={setAlertMessage}
          setShowAlert={setShowAlert}
        />
      )}
    </LoginSignupSectionContainer>
  );
};

const LoginModal = ({
  modalSectionType,
  setModalSectionType,
  showLoginModal,
  handleClose,
  locale,
}: LoginModalProps) => {
  return (
    <StyledModalContainer
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={showLoginModal}
      onClose={() => handleClose()}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      className="gb-login-modal"
    >
      <Fade in={showLoginModal}>
        <StyledModal>
          <DescriptionSection locale={locale} />
          <LoginSignupSection
            modalSectionType={modalSectionType}
            setModalSectionType={setModalSectionType}
            locale={locale}
            handleClose={handleClose}
          />
        </StyledModal>
      </Fade>
    </StyledModalContainer>
  );
};

export default LoginModal;
